import { useTheme } from '@mui/material/styles';
import { HelpOutlineOutlined } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { getBankName } from './helpers';
import { OperationUnknown } from './interfaces';

interface Props {
  operation: OperationUnknown;
}

const UnknownOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, senderMsisdn, transferAmount, cost } = operation;

  const error =
    details.errorCode && details.errorMessage
      ? { errorCode: details.errorCode, errorMessage: details.errorMessage }
      : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HelpOutlineOutlined, color: theme.palette.grey['700'] },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            {
              label: locales.operation.label.senderMsisdn,
              value: detailsValueFormatter(senderMsisdn)
            },
            { label: locales.operation.label.debitBank, value: getBankName(details.debitAccount) },
            { label: locales.operation.label.senderEmail, value: details.senderEmail },
            { label: locales.operation.label.debitAccountNumber, value: details.debitAccount.accountNumber },
            { label: locales.operation.label.transferAmount, value: formatToAmount(transferAmount.value) },
            { label: locales.operation.label.creditBank, value: getBankName(details.creditAccount) },
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) },
            { label: locales.operation.label.creditAccountNumber, value: details.creditAccount.accountNumber }
          ]}
        />
      }
    />
  );
};

export default UnknownOperation;
